<script lang="ts">
  import Businesses from '../constants/Business';
  import EnecomUtil from '../util/EnecomUtil';
  import { loginUser, saveJwt } from '../components/auth/LoginUser';
  import { push, link } from 'svelte-spa-router';
  import Loading from '../etc/loader.svelte';
  import RepositoryFactory, { AUTHENICATE } from '../repositories/RepositoryFactory';
  import { form, field } from 'svelte-forms';
  import { required } from 'svelte-forms/validators';

  const businessItems: any = Businesses.LOGIN_BUSINESSES;

  // ログイン済の場合には、トップページに遷移
  if ($loginUser) {
    push('/');
  }

  const isEnecom: boolean = EnecomUtil.isEnecom();
  const businessCode = field('businessCode', isEnecom ? 'UMOBILE_D_ENECOM' : 'HIKARI_COLLABO', [required()]);
  const loginId = field('loginId', '', [required()]);
  const password = field('password', '', [required()]);
  const myForm = form(businessCode, loginId, password);

  let errorMessage: string = '';
  let isLoading = false;

  const authenicateRepository = RepositoryFactory[AUTHENICATE];
  const handleLogin = async () => {
    let isFormValid = false;
    await myForm.validate().then(() => {
      isFormValid = $myForm.valid;
    });
    if (!isFormValid) {
      return false;
    }

    isLoading = true;

    await authenicateRepository
      .login({
        loginId: $loginId.value,
        password: $password.value,
        businessCode: $businessCode.value
      })
      .then((res) => {
        if (res.isDeleted) {
          isLoading = false;
          errorMessage =
            'ご契約がすでに解約されている等によりマイページへのログインはできません。<br />ご不明な点がございましたらカスタマーセンターにお問い合わせください';
        } else {
          isLoading = false;
          saveJwt(res.token);
          push('/');
        }
      })
      .catch((error) => {
        isLoading = false;
        errorMessage = 'ログインID/パスワードを正しく入力してください';
      });
  };

  const onKeyPress = (e: KeyboardEvent) => {
    e.key === 'Enter' && handleLogin();
  };
</script>

{#if isLoading}
  <Loading />
{/if}

<!-- 本体 -->
<div class="md:h-screen flex flex-col justify-between items-center login-background">
  <header class="container top-0 z-0">
    <div class="flex justify-center items-center" style="height:56px">
      {#if isEnecom}
        <img style="height:36px" class="object-none w-full" src="/image/enecom_logo.png" alt="logo" />
      {:else}
        <img style="height:36px" class="object-none w-full" src="/image/unext_communication_logo.svg" alt="logo" />
      {/if}
      <hr class="items-center" style="border: 1px solid rgba(0,10,23,0.2)" />
    </div>
  </header>

  <main class="container mt-10 md:mt-20 mb-auto">
    {#if !isEnecom}
      <div class="grid place-items-center">
        <div class="flex flex-wrap justify-center flex-col md:flex-row">
          <div class="flex-none main-service-font mx-3">U-mobile</div>
          <div class="flex-none main-service-font mx-3">U-mobile PREMIUM</div>
          <div class="flex-none main-service-font mx-3">U-mobile*E</div>
          <div class="flex-none main-service-font mx-3">U-NEXT光01</div>
          <div class="flex-none main-service-font mx-3">U-NEXT光</div>
          <div class="flex-none main-service-font mx-3">U-mobile LTE</div>
          <div class="flex-none main-service-font mx-3">withUnet</div>
        </div>
      </div>
    {/if}

    {#if errorMessage}
      <div class="grid place-items-center mt-10">
        <div class="content-center shadow-sm alert-background">
          <div class="bg-red-100 border-t border-b border-red-500 text-red-700 px-4 py-3" role="alert">
            <p class="font-bold">
              {@html errorMessage}
            </p>
          </div>
        </div>
      </div>
    {/if}

    <div class="grid place-items-center mt-10">
      <div class="content-center shadow-sm p-5 form-background">
        <form>
          <div class="grid place-items-center">
            <div class="form-container">
              {#if !isEnecom}
                <div class="">
                  <label for="businessCode" class="block mt-2 form-input-label">サービス</label>
                  <select
                    id="businessCode"
                    name="businessCode"
                    class="block p-3 mt-1 appearance"
                    bind:value={$businessCode.value}
                    required
                  >
                    {#each businessItems as { code, name }}
                      <option value={code}>{name}</option>
                    {/each}
                  </select>
                  {#if $myForm.hasError('businessCode.required')}
                    <p class="text-red-500 text-xs mt-2">サービスを選択してください</p>
                  {/if}
                </div>
              {/if}
              <div class="">
                <label for="loginId" class="block mt-4 form-input-label">ログインID（お客様ID、ユーザーID）</label>
                <input
                  type="text"
                  id="loginId"
                  name="loginId"
                  autocomplete="off"
                  class="block p-3 mt-1 appearance-none"
                  bind:value={$loginId.value}
                  required
                />
                {#if $myForm.hasError('loginId.required')}
                  <p class="text-red-500 text-xs mt-2">ログインIDを入力してください</p>
                {/if}
              </div>
              <div>
                <label for="password" class="block mt-4 form-input-label">パスワード</label>
                <input
                  type="password"
                  id="password"
                  name="password"
                  class="block p-3 mt-1 appearance-none"
                  bind:value={$password.value}
                  on:keypress={onKeyPress}
                  required
                />
                {#if $myForm.hasError('password.required')}
                  <p class="text-red-500 text-xs mt-2">パスワードを入力してください</p>
                {/if}
              </div>

              <button type="button" class="py-3 mt-10 tracking-widest form-button" on:click={handleLogin}
                >ログイン</button
              >
              <div class="grid place-items-center">
                <div class="flex justify-between text-center mt-6">
                  <p class="inline-block cursor-pointer form-help-text">
                    <a href={`/confirm/login-info/`} use:link>ログインIDがわからない方</a><br /><a
                      href={`/reset/login-info/`}
                      use:link>パスワードを忘れた方</a
                    >
                  </p>
                  <div>
                    <div />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>

    {#if !isEnecom}
      <div class="grid place-items-center px-5">
        <div class="justify-between items-center mt-10">
          <a href="https://www.yumobile.jp/?utm_source=umobile&utm_medium=official&utm_campaign=mypage"
            ><img class="object-contain banner" src="/image/banner-yu.png" alt="banner-yu" /></a
          >
        </div>
        <div class="justify-between items-center mt-4">
          <a href="https://lp.yumobile.jp/r/m/?utm_source=umobile_k&utm_medium=official&utm_campaign=mypage"
            ><img class="object-contain banner" src="/image/banner-kakaku.png" alt="banner-kakaku" /></a
          >
        </div>
      </div>
    {/if}
  </main>

  {#if !isEnecom}
    <footer class="container px-5 my-5">
      <div class="grid place-items-center">
        <div class="flex space-x-4 justify-center md:justify-between flex-wrap">
          <div class="flex-none footer-service-font">U-mobile</div>
          <div class="flex-none footer-service-font">/</div>
          <div class="flex-none footer-service-font">U-mobile PREMIUM</div>
          <div class="flex-none footer-service-font">/</div>
          <div class="flex-none footer-service-font">U-mobile*E</div>
          <div class="flex-none footer-service-font">/</div>
          <div class="flex-none footer-service-font">U-NEXT光01</div>
          <div class="flex-none footer-service-font">/</div>
          <div class="flex-none footer-service-font">U-NEXT光</div>
          <div class="flex-none footer-service-font">/</div>
          <div class="flex-none footer-service-font">U-mobile LTE</div>
          <div class="flex-none footer-service-font">/</div>
          <div class="flex-none footer-service-font">withUnet</div>
        </div>
      </div>
    </footer>
  {/if}
</div>

<style lang="postcss">
  /* UXデザインチームのワイヤーフレームにて指定されたCSS設定に */
  .login-background {
    background-color: white;
  }
  .main-service-font {
    color: #404040;
    font-size: 16px;
    font-weight: bold;
  }
  .footer-service-font {
    color: rgba(0, 0, 0, 0.8);
    font-size: 16px;
  }
  select {
    font-size: 14px;
    color: rgba(0, 10, 23, 1);
    background-color: rgba(1, 6, 13, 0.06);
    width: 100%;
    height: 48px;
    @apply focus:ring-0 focus:ring-blue-200 focus:border-transparent;
  }
  input[type='text'],
  input[type='password'] {
    font-size: 14px;
    color: rgba(0, 10, 23, 1);
    background-color: rgba(1, 6, 13, 0.06);
    width: 100%;
    height: 48px;
    @apply focus:ring-0 focus:ring-blue-200 focus:border-transparent;
  }
  .form-background {
    width: 720px;
    background-color: rgba(0, 0, 0, 0.02);
  }
  @media screen and (max-width: 640px) {
    .form-background {
      width: 100%;
    }
  }
  .form-input-label {
    font-size: 16px;
    color: rgba(0, 0, 0, 1);
  }
  .form-button {
    font-size: 14px;
    font-weight: bold;
    color: #ffffff;
    background-color: #0fb9f5;
    width: 100%;
    height: 56px;
  }
  .form-button:hover {
    text-decoration: none;
    -webkit-filter: brightness(1.1);
    filter: brightness(1.1);
  }
  .form-help-text {
    font-size: 16px;
    color: #0fb9f5;
  }
  .banner {
    width: 640px;
  }

  .form-container {
    width: 352px;
  }
  @media screen and (max-width: 640px) {
    .form-container {
      width: 100%;
    }
  }
</style>
